import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const TenantContext = createContext(null);
export const useTenant = () => useContext(TenantContext);

const KEY = "active_tenant_id";

export function TenantProvider({ children }) {
  const { user } = useAuth();
  const isSuper = user?.role === "super_admin";
  const [tenants, setTenants] = useState([]);
  const [activeTenant, setActiveTenant] = useState(() => localStorage.getItem(KEY) || "");

  useEffect(() => {
    if (!user) return; // wait until auth resolves before touching the scope
    if (isSuper) {
      api.get("/tenants").then((r) => setTenants(r.data)).catch(() => {});
    } else if (localStorage.getItem(KEY)) {
      // A non-super user must never carry a tenant scope.
      localStorage.removeItem(KEY);
      setActiveTenant("");
    }
  }, [user, isSuper]);

  const selectTenant = useCallback((tid) => {
    const next = tid === "__all__" ? "" : tid;
    if (next) localStorage.setItem(KEY, next);
    else localStorage.removeItem(KEY);
    setActiveTenant(next);
    // Reload so every page refetches data under the new tenant scope.
    window.location.reload();
  }, []);

  const activeName = tenants.find((t) => t.tenant_id === activeTenant)?.company_name || "";

  return (
    <TenantContext.Provider value={{ isSuper, tenants, activeTenant, activeName, selectTenant }}>
      {children}
    </TenantContext.Provider>
  );
}
